export default {
  giftCardItem: {
    id: 'checkout_summary_gift_card_item',
    defaultMessage: 'Back Market Gift Card - {price}',
  },
  emailDelivery: {
    id: 'checkout_summary_gift_card_email_delivery',
    defaultMessage: 'Email delivery',
  },
}
